export const socials = [
    {
        name: "facebook",
        url: "https://www.facebook.com/sharer/sharer.php?u=https://edwin-do-shoppies.netlify.app/",
        color: "#3b5998",
        icon: ['fab','facebook']    
    },
    {
        name: "Twitter",
        url: "https://twitter.com/intent/tweet?url=https://edwin-do-shoppies.netlify.app/&text=Nominate your favourite movies for the upcoming Shoppies!",
        color: "#00acee",
        icon: ['fab','twitter'],
    },
    {
        name: "LinkedIn",
        url: "https://www.linkedin.com/shareArticle?mini=true&url=https://edwin-do-shoppies.netlify.app//&title=&summary=Nominate your favourite movies for the upcoming Shoppies! &source=Shoppies",
        color: "#0e76a8",
        icon: ['fab','linkedin'], 
    },
    {
        name: "Email",
        url: "mailto:info@example.com?&subject=&body=https://edwin-do-shoppies.netlify.app/ Nominate your favourite movies for the upcoming Shoppies! ",
        color: "#b3b3b3",
        icon: ['fas','envelope'] ,
    },
]